/*项目定制页面*/
export default [{
		//德肯地图GIS
		path: '/dekenMap',
		name: 'dekenMap',
		component: () =>
			import('@/page/projectDingZhi/deken/dekenMap.vue')
	}, {
		//德肯测温点配置
		path: '/cableconfig',
		name: 'cableconfig',
		component: () =>
			import('@/page/projectDingZhi/deken/cableconfig.vue')
	}, {
		//华普电定制页面
		path: '/hpPowerUnit',
		name: 'hpPowerUnit',
		component: () =>
			import('@/page/projectDingZhi/huapu/hpPowerUnit.vue')
	}, {
		//华普气定制页面
		path: '/huapuGas',
		name: 'huapuGas',
		component: () =>
			import('@/page/projectDingZhi/huapu/huapuGas/huapuGas.vue')
	}, {
		//华普水定制页面
		path: '/huapuWater',
		name: 'huapuWater',
		component: () =>
			import('@/page/projectDingZhi/huapu/huapuWater/huapuWater.vue')
	}, {
		//华普配置单位概况缺陷
		path: '/unitDefectPage',
		name: 'unitDefectPage',
		component: () =>
			import('@/page/unitProfile/unitDefectPage.vue')
	}, {
		//天澄分摊费管理
		path: '/tcDivideManager',
		name: 'tcDivideManager',
		component: () =>
			import('@/page/projectDingZhi/tiancheng/tcDivideManager.vue')
	},
	{
		//天澄分摊费列表
		path: '/tcDivideExpense',
		name: 'tcDivideExpense',
		component: () =>
			import('@/page/projectDingZhi/tiancheng/tcDivideExpense.vue')
	}, {
		//金电手工填报实时值
		path: '/realTimeValue',
		name: 'realTimeValue',
		component: () =>
			import('@/page/manuallyFillIn/realTimeValue.vue')
	}, {
		//金电手工填报历史值
		path: '/historicalValue',
		name: 'historicalValue',
		component: () =>
			import('@/page/manuallyFillIn/historicalValue.vue')
	},
	//天津石化
    {
        // 天津石化综合看板
		path: '/comprehensive',
		name: 'comprehensive',
		component: () =>
			import('@/page/tianjinPetrifaction/comprehensive.vue')
	},
	{
        // 天津石化数据统计
		path: '/statistics',
		name: 'statistics',
		component: () =>
			import('@/page/tianjinPetrifaction/statistics.vue')
	},
	{
        // 天津石化报警及异常处理
		path: '/abnormal',
		name: 'abnormal',
		component: () =>
			import('@/page/tianjinPetrifaction/abnormal.vue')
	},
	{
        // 天津石化检测报告
		path: '/monitoringReport',
		name: 'monitoringReport',
		component: () =>
			import('@/page/tianjinPetrifaction/monitoringReport.vue')
	},

]